export default {

  addToCart: "Add to Cart",
  stock: "Stock",
  price:"price",
  outOfStock: "Out of Stock",
  toman: "Toman",
  showAll:"see All",
  retry:"try again",
  urls:{
    ProductCategory:"/en/product-category",
    Product:"/en/product",
  }
};
